import { Theme } from '@material-ui/core'
import Chip from '@material-ui/core/Chip'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import { Autocomplete } from '@material-ui/lab'
import React, { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { IAutocompleteOption, IAutocompleteValue } from './types'

interface IAutoCompleteChipProps {
  label: string
}
function AutocompleteChip(props: IAutoCompleteChipProps) {
  const classes = useStyles()

  return <Chip classes={{ root: classes.chip }} color="primary" {...props} />
}

interface IMultipleAutocompleteProps {
  disabled: boolean
  handleChange: (value: any) => void
  options: IAutocompleteOption[] | undefined
  value: IAutocompleteValue[] | undefined
}

// New component, might need some adaptive code whenever used for other fields
export function MultipleAutocomplete(props: IMultipleAutocompleteProps) {
  const { t } = useTranslation()
  return (
    <Autocomplete
      multiple
      disabled={props.disabled}
      options={props.options ?? []}
      getOptionLabel={(option) => option.name}
      value={props.value}
      onChange={(_event: ChangeEvent<Record<string, unknown>>, value: IAutocompleteValue[]) => {
        props.handleChange(value)
      }}
      renderTags={(tagValue, getTagProps) => {
        return tagValue.map((option, index) => (
          <AutocompleteChip {...getTagProps({ index })} label={option.name} key={option.id} />
        ))
      }}
      renderInput={(params) => <TextField {...params} variant="outlined" placeholder={t('Search')} color="secondary" />}
    />
  )
}

function useStyles() {
  return makeStyles((theme: Theme) => ({
    chip: {
      margin: theme.spacing(1 / 2),
      fontSize: '13px',
      borderRadius: '10px',
      background: theme.palette.primary.main,
      border: 'none',
      color: 'white',
      overflow: 'hidden',
      marginBottom: '5px',
    },
  }))()
}
